import { manufacturingFetch } from "@/lib/manufacturingClient";

export type MfgMaterialMergeResponse = {
  ok?: boolean;
  error?: string;
  blockers?: Array<{ code: string; message: string }>;
  deleted?: boolean;
  from_material_id?: string;
  to_material_id?: string;
  from_code?: string;
  from_name?: string;
  to_code?: string;
  to_name?: string;
  recipe_lines?: number;
  recipes?: number;
  use_members_transferred?: number;
  use_members_dropped?: number;
  cost_entries?: number;
  issuance_events?: number;
  count_lines_repointed?: number;
  count_lines_dropped?: number;
  transfers?: number;
  aliases_repointed?: number;
  aliases_dropped?: number;
  on_hand_moved?: number;
  keeper_on_hand_after?: number;
  keeper_unit_cost_after?: number;
};

/** Full merge: transfer dependents + inventory onto keeper, hard-delete discard. */
export function mergeManufacturingMaterials(payload: {
  from_material_id: string;
  to_material_id: string;
  dry_run?: boolean;
}) {
  return manufacturingFetch<MfgMaterialMergeResponse>("/api/mfg/materials/merge", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });
}
